import { Box, Flex, Link, Stack, useDisclosure, useMediaQuery } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'
import { Logo } from '../../../assets/icons/Logo'
import NavItems from '../../../app/components/Navigation'
import DrawerMenu from '../../../app/components/DrawerMenu'
import 'react-toastify/dist/ReactToastify.css'
import './toasts.css'
import AlarmToastManager from '../components/AlarmToastManager'
import React, { useEffect } from 'react'
import { AlarmsCountContextProvider } from '../../../context/AlarmsCountContext'
import MethodiaLogo from '../../../assets/icons/Methodia'
import { METHODIA_SUBDOMAIN, getSubdomain } from '../../../utils/helpers'
import Cookies from 'js-cookie'
import { useSendCsvReport } from '../hooks/useReportSocket'
import { DeviceStatusContextProvider } from '../../../context/DeviceStatusContext'
import { LeaveFeedback } from '../components/LeaveFeedback'

export const Layout: React.FC = () => {
  const methodiaAiotCookie = Cookies.get('aiot_methodia_user')
  const { sendCsvReport } = useSendCsvReport()
  const { isOpen, onOpen, onClose } = useDisclosure()

  useEffect(() => {
    const token = window.localStorage.getItem('aiot_t')
    const socketServerURL = `${process.env.REACT_APP_WS_URL}/ws/report/?token=${token}`
    const socket = new WebSocket(socketServerURL)

    socket.onmessage = async (event) => {
      const data = JSON.parse(event.data)

      for (const element of data) {
        if (element?.saved_as === 'csv') {
          await sendCsvReport(element)
        } else if (element?.saved_as === 'pdf') {
          console.log('Download PDF')
          // TODO: Implement PDF sending
        }
      }
    }
    return () => socket.close()
  }, [sendCsvReport])

  const [isSmallerThan1200] = useMediaQuery('(max-width: 1200px)')
  const bottomMenuItems = [
    { text: 'Leave feedback' },
    // { text: 'Terms of service' },
    // { text: 'Privacy policy' },
  ]

  const subdomain = getSubdomain()
  return (
    <>
      <AlarmsCountContextProvider>
        <DeviceStatusContextProvider>
          <Flex w="full" h="100vh" bgColor="#F7F9FD">
            <Flex
              direction="column"
              px={7}
              py={{ base: 2, sm: 4 }}
              borderWidth={1}
              bgColor="white"
              as="nav"
              justify="space-between"
              hidden={isSmallerThan1200}
            >
              <Stack
                direction="column"
                spacing={10}
                as="ul"
                justify="space-between"
                w="full"
              >
                {subdomain === METHODIA_SUBDOMAIN || methodiaAiotCookie ? (
                  <MethodiaLogo w={150} h={50} />
                ) : (
                  <Logo w={40} h={5} />
                )}

                <NavItems />
              </Stack>
              <Stack direction="column" as="ul" w="full" spacing={6} mt={20}>
                {bottomMenuItems.map(({ text }) => (
                  <Link
                    as="li"
                    listStyleType="none"
                    fontSize="sm"
                    onClick={onOpen}
                    cursor="pointer"
                    _hover={{ color: 'blue.500' }}
                  >
                    {text}
                  </Link>
                ))}
              </Stack>
            </Flex>

            <Box borderWidth={1} py={{ base: 4, sm: 7 }} w="full" overflowX="auto">
              {isSmallerThan1200 && (
                <Stack
                  direction="row"
                  justify="space-between"
                  w="full"
                  mb={6}
                  px={{ base: 6, lg: 0 }}
                >
                  <Logo w={40} h={5} />
                  <DrawerMenu />
                </Stack>
              )}
              <Box>
                <Box mx={{ base: 0, laptopM: 6 }}>
                  <Outlet />
                </Box>
              </Box>
            </Box>
          </Flex>
          <LeaveFeedback isOpen={isOpen} onClose={onClose} />
          <AlarmToastManager />
        </DeviceStatusContextProvider>
      </AlarmsCountContextProvider>
    </>
  )
}
